import {GoogleMap} from '@crema/modules/thirdParty';

export default GoogleMap;
